import { render, staticRenderFns } from "./CardCustom.vue?vue&type=template&id=3e40a7f6&scoped=true&"
import script from "./CardCustom.vue?vue&type=script&lang=js&"
export * from "./CardCustom.vue?vue&type=script&lang=js&"
import style0 from "./CardCustom.vue?vue&type=style&index=0&id=3e40a7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40a7f6",
  null
  
)

export default component.exports